import { cva } from "class-variance-authority";
import clsx from "clsx";

export const inputBase = cva(
  [
    "rounded-sm",
    "border",
    "px-8",
    "py-8",
    "border-black",
    "w-full",
  ],
  {
    variants: {
      borderColor: {
        "black": ["border-black"],
        "gray": ["border-gray-300"],
      },
      bgColor: {
        "white": ["bg-white"],
        "gray": ["bg-gray-50"],
      },
      error: {

      },
    },
    defaultVariants: {
      borderColor: "black",
      bgColor: "white",
    }
  }



);

export const buttonBase = cva(
  [
    "text-center",
    "inline-block"
  ],
  {
    variants: {
      variant: {
        ol: [
          "bg-transparent",
          "text-black",
          "border",
          "border-black",
          "text-sm",
          "bg-white",
        ],
        text: ["text-gray-500"],
        blue: ["bg-blue-500", "text-white"],
        green: ["bg-green-500", "text-white"],
        red: ["bg-red-500", "text-white"],
        gray: ["bg-gray-800", "text-white"],
        cancel: ["bg-gray-400", "text-white"],
        disabled: ["bg-gray-200", "text-gray-500", "cursor-not-allowed"],
        default: ["bg-black", "text-white", "rounded-full",
          "border",
          "border-black",
        ],
      },
      size: {
        inline: ["py-3", "px-16", "text-14"],
        sm: ["min-w-96", "py-6", "px-8", "text-12"],
        md: ["min-w-140", "py-8", "px-20", "text-15"],
        lg2: ["min-w-220", "py-8", "px-24", "text-16"],
        lg: ["min-w-250", "py-12", "px-24", "text-18"],
      },
      round: {
        full: ["rounded-full"],
        sm: ["rounded-sm"],
        none: ["rounded-none"],
      },
      loading: {
        true: ["opacity-50", 'pointer-events-none'],
        false: [],
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      round: "full",
      loading: false,
    }
  },
);


export const textIconClass = clsx(
  "text-13",
  "leading-none",
  "ml-1",
  "-mt-1",
  "font-bold",
);